import React from 'react';
import RouterBase from "app/routes/RouterBase";


export default class TranslationsPages extends RouterBase {

    get className() {
        return 'app-wrapper';
    }

    get routes() {
        return [
            {
                path: '',
                asyncComponent: () => import('./main'),
                requiredRoles: ['super-admin', 'local-translation-update', 'global-translation-update', 'global-translation-publish']
            }
        ]
    }
}